import { ICompany } from "@models";
import http from "../http-common";

/**
 * Retrieves company information based on the provided ID.
 *
 * @param {any} id - The ID of the company to retrieve information for
 * @return {Promise<ICompany>} A promise that resolves with the company information
 */
const getInfo = (id: string) => {
  return http.get<ICompany>(`/${id}/consent-request`);
};
const submitForm = (id: string, data: any) => {
  return http.post<any>(`/${id}/consent-request`, data);
};
const searchConsents = (id: string, data: any) => {
  return http.post<any>(`/${id}/search`, data);
};
const verifyOTP = (id: string, ref_id: string, data: any) => {
  return http.post<any>(`/${id}/consent/${ref_id}/otp/verify`, data);
};
const resendOTP = (id: string, ref_id: string, data: any) => {
  return http.post<any>(`/${id}/consent/${ref_id}/otp/resend`, data);
};
const checkConsentResponse = (id: string, ref_id: string) => {
  return http.get<any>(`/${id}/consent/${ref_id}/result`);
};

const ConsentFormService = {
  getInfo,
  submitForm,
  searchConsents,
  verifyOTP,
  resendOTP,
  checkConsentResponse,
};

export default ConsentFormService;
